const STORAGE_KEY = 'partnerOnboardingDraft';
const LEGACY_KEY = 'partnerSignUpStepOne';

/**
 * Rascunho do cadastro de parceiro.
 *
 * Antes só o passo 1 era guardado, e o passo atual não era guardado nunca: quem
 * recarregava a página no meio do fluxo voltava para o começo. Aqui o passo
 * também é persistido — mas **a senha não**. Por isso `read` limita o passo
 * restaurado ao passo em que a senha é digitada: voltar para depois dele deixaria
 * o formulário com um campo obrigatório vazio e invisível.
 *
 * sessionStorage (e não localStorage) porque isto é CPF, telefone e data de
 * nascimento de uma pessoa: morre junto com a aba.
 */
const partnerDraft = {
    read: (maxRestorableStep = 1) => {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);

            if (!raw) {
                return null;
            }

            const draft = JSON.parse(raw);

            return {
                ...draft,
                step: Math.min(Number(draft?.step) || 1, maxRestorableStep),
            };
        } catch (error) {
            return null;
        }
    },

    save: ({ step, business, account }) => {
        try {
            // A senha fica só em memória. Guardá-la aqui deixaria a credencial
            // legível para qualquer aba do mesmo domínio.
            const { password, confirmPassword, ...safeAccount } = account || {};

            sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
                step,
                business: business || {},
                account: safeAccount,
            }));
        } catch (error) {
            // Modo privativo ou storage cheio: o cadastro segue, só não sobrevive a um refresh.
        }
    },

    clear: () => {
        try {
            sessionStorage.removeItem(STORAGE_KEY);
            sessionStorage.removeItem(LEGACY_KEY);
        } catch (error) {
        }
    },
};

export default partnerDraft;
